<template>
    <b-modal id="files-modal"
                ref="fileManagement"
                hide-footer
                size="md"
                centered
                scrollable
                modal-class="modal-table modal-files multiselect-modal"
    >
        <template #modal-header="{ close }" class="modal-header">
            <div class="title">{{`${getFmText('files')} (${currItemName})`}}</div>
            <i class="icon icon-close" @click="close()"></i>
        </template>

        <div class="modal-search">
            <b-form-group>
                <!-- Поле ввода текста для поиска -->
                <b-form-input ref="searchTextField" v-model="searchText" :placeholder="getFmText('search')" type="text"/>
                <!-- Кнопка очистки текста -->
                <i class="icon icon-close clear-button" @click="() => { searchText = '' }"/>
            </b-form-group>  
        </div>
        
        <b-tabs v-model="activeVersionTab" class="version-tabs">
            <b-tab :title="getLocText('current_version')"></b-tab>
            <b-tab :title="getLocText('past_versions')"></b-tab>
        </b-tabs>
        
        <div class="table-container modal-table-card mb-3">
            <p class="file-not-found" v-show="!searchedFilesAll.length">{{ getFmText('not_found') }}</p>

            <div class="file-info" v-for="item in searchedFilesAll" :key="item.id">
                <div :key="item.id" class="d-flex align-items-center">
                    <template >
                        <p  class="name">
                            <file-icons :filename="item.file_name"></file-icons>
                            <span style="cursor: pointer" @click="()=>$emit('triggDownloadFile', item.file_name, item.id)">{{item.file_name}}</span>
                        </p>
                        <p class="size">({{getCatName(item.category)}})</p>
                        <p class="size">{{item['size']}}</p>
                    </template>
                </div>
            </div>
        </div>
        
        <b-button
                size="sm"
                variant="outline-success"
                class="download"
                :disabled="attachedFilesAll.length === 0 || downloadTracker.isDownloading"
                @click="$emit('triggDownloadAllFiles', attachedFilesAll, downloadTracker)"
            >
                <file-download-ring v-if="downloadTracker.isDownloading" :progress="downloadTracker.progress" />
                {{ getFmText('download_all') }}
        </b-button>
    </b-modal>
</template>

<script>
import FileUpdownMixin from '../mixins/file-updown-mixin';
import FileIcons from './file-icons.vue';
import FileDownloadRing from './file-download-ring.vue';

export default {
    name: "modal-all-files-management",
    components: { FileIcons, FileDownloadRing },
    props: {
        allFiles: Array,
        hasFilesTable: {
            required: false,
            default: false
        },
    },
    mixins: [FileUpdownMixin],
    data() {
        return {
            selectedCategory: 'All',
            searchText: '',
            currItem: null,
            newFileCodes: null,
            dataChanged: false,
            activeVersionTab: 0,
            downloadTracker: { progress: 0, isDownloading: false },
        }
    },
    methods: {
        async showModal(item) {  
            this.searchText = '';          
            this.currItem = item;

            this.newFileCodes = item.files;
            await this.loadDict();
            this.$refs.fileManagement.show();
        },

        getCatName(code) {
            const currCat = this.categoryFiles.find(item => item.value === code);
            return currCat ? currCat.name : null
        },
        
        stringToUnicode(string) {
            let chr = '';
            if (string.length === 0) return hash;
            for (let i = 0; i < string.length; i++) {
                chr += string.charCodeAt(i); 
            }
            return chr;
        },

       getFmText(field, extra = null) {
            const link = 'modules.budget_request.files_management.';
            return this.getText(link, field, extra)
        },
    },
    computed: {
        attachedFilesAll() {
            let newArr = [];
            const allFilesCopy = JSON.parse(JSON.stringify(this.allFiles))
            if (this.hasFilesTable) {
                newArr = allFilesCopy;
            } else {
                allFilesCopy.forEach(item => {
                    if (this.currItem && this.currItem.files && this.currItem.files.includes(this.stringToUnicode(item.category + item.file_name))) {
                        this.$set(item, 'row_id', item.id);
                        newArr.push(item);
                    }
                });
            };
            return newArr;
        },

        searchedFilesAll() {
            if (!this.attachedFilesAll) return [];
            const isCurrent = this.activeVersionTab === 0;
            let sortedFiles = JSON.parse(JSON.stringify(this.attachedFilesAll));
            sortedFiles = sortedFiles.filter(item => {
                let result = true;
                if (this.searchText.length) {
                    result = result && item.file_name.toLowerCase().includes(this.searchText.toLowerCase());
                };
                result = result && item.row_id;
                result = result && (isCurrent ? item.is_current_version : !item.is_current_version);
                return result;
            });

            return sortedFiles.sort((a, b) => a.file_name > b.file_name ? 1 : -1);
        },

        currItemName() {
            let curName = '';
            const name = `name_${this.lng}`;
            if (this.currItem) {
                if (this.currItem[name]) curName = this.currItem[name]
                else curName = this.currItem.name_ru;
            }
            return curName
        }
    },
}

</script>

<style scoped>
::v-deep .version-tabs .nav-tabs {
    position: static;
    border-top: none;
    width: 100%;
}
::v-deep .version-tabs .nav-tabs .nav-item {
    flex: 1;
    margin-left: 0;
    margin-right: 0;
}
::v-deep .version-tabs .nav-tabs .nav-item .nav-link {
    text-align: center;
}
::v-deep .version-tabs .nav-tabs .nav-item .nav-link.active {
    background-color: #F7F9FC;
}
.file-cat-name {
    font-size: 0.9rem;
}
.file-not-found {
    font-size: 0.8rem;
    font-style: italic;
    color: #A8B5CD;
    margin-left: 2rem;
}
#files-modal .icon-close {
    cursor: pointer;
}
.modal-header {
    display: flex;
    justify-content: space-between;
}
.modal-header div {
    flex-grow: 1;
    text-align: center;
}
.download {
    display: block;
    margin: auto;
    min-width: 8rem;
}
.modal-search {
    margin-top: 15px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}
.table-container {
    background-color: #F7F9FC;
    border-left: 1px solid #E2E5EB;;
    border-right: 1px solid #E2E5EB;;
    border-bottom: 1px solid #E2E5EB;;
    padding-right: 0;
}
.file-info {
    overflow: hidden;
    max-width: 100%;
    cursor: pointer;
    transition: background-color 0.15s;
}
.file-info:hover {
    background-color: #E9F4FD;
}
.file-info .d-flex {
    min-width: 0;
}
.file-info p {
    margin-bottom: 0;
    white-space: nowrap;
    flex-shrink: 0;
}
.file-info p.name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 1;
}
.file-info p:first-child,
.file-info p:nth-child(2) {
    padding-left: 1rem;
}
.file-info p:last-child {
    /* padding-right: 1rem; */
    margin-right: 1rem;
}
</style>